<script setup lang="ts">
import { ref } from "vue";
import AnimateHeight from "vue-animate-height";

defineProps<{
  toolName: string;
  toolInput: Record<string, unknown>;
  result: unknown | null;
  isError: boolean;
  isLoading: boolean;
}>();

const expanded = ref(false);
</script>

<template>
  <div class="chat-tool-block mb-px-8 rounded-8 overflow-hidden border">
    <button
      type="button"
      class="chat-tool-button gap-px-8 px-px-12 py-px-8 flex w-full items-center"
      @click="expanded = !expanded">
      <!-- Status indicator -->
      <span
        v-if="isLoading"
        class="chat-tool-spinner h-3 w-3 shrink-0 animate-spin rounded-full border-2 border-t-transparent" />
      <font-awesome-icon
        v-else-if="isError"
        :icon="['fas', 'circle-xmark']"
        class="chat-tool-error icon-xs shrink-0" />
      <font-awesome-icon
        v-else
        :icon="['fas', 'circle-check']"
        class="chat-tool-success icon-xs shrink-0" />

      <span class="chat-text-main t-xs">{{ toolName }}</span>
      <font-awesome-icon
        :icon="['fas', 'chevron-down']"
        class="chat-text-muted icon-xs duration-fast ease-standard ml-auto transition-transform"
        :class="{ 'rotate-180': expanded }" />
    </button>

    <AnimateHeight :height="expanded ? 'auto' : 0">
      <div class="px-px-12 pb-px-12">
        <p class="chat-text-muted t-caption-bold mb-px-4">Arguments</p>
        <pre class="chat-code-block chat-text-main rounded-4 px-px-8 py-px-6 t-caption overflow-x-auto whitespace-pre-wrap">{{
          JSON.stringify(toolInput, null, 2)
        }}</pre>

        <template v-if="!isLoading && result !== null">
          <p class="chat-text-muted t-caption-bold mb-px-4 mt-px-8">Result</p>
          <pre
            :class="isError ? 'chat-tool-result-error' : 'chat-text-main'"
            class="chat-code-block rounded-4 px-px-8 py-px-6 t-caption overflow-x-auto whitespace-pre-wrap"
            >{{ JSON.stringify(result, null, 2) }}</pre
          >
        </template>
      </div>
    </AnimateHeight>
  </div>
</template>
